// extracted by mini-css-extract-plugin
module.exports = {"cell":"filters_cell__3pzsG","first_cell":"filters_first_cell__2zVME filters_cell__3pzsG","remove_all":"filters_remove_all__9qBDL"};